import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Modal } from 'react-bootstrap';
import { IoChatbubbleEllipsesSharp } from "react-icons/io5";
import { FaPhoneVolume } from 'react-icons/fa';
import { MdEmail } from 'react-icons/md';

import '../ProblemsSection/ProblemsSection.css';
import '../../ColumbusPage/all/Main.css';

import Badge from '../ServiceSection/Badge';
import ContactForm from './../../MainHeader/ContactForm';

// --- Data Configuration ---
const roofingIssues = [
    "Roof Leaks",
    "Damaged Shingles",
    "Storm & Wind Damage",
    "Hail Damage",
    "Flashing Issues",
    "Water Ponding",
    "Rotting",
    "Poor Ventilation",
    "Gutter Issues"
];

const getIconClass = (title) => {
    const map = {
        "Roof Leaks": "fa-house-crack",
        "Damaged Shingles": "fa-table-cells",
        "Storm & Wind Damage": "fa-wind",
        "Hail Damage": "fa-cloud-meatball",
        "Flashing Issues": "fa-screwdriver-wrench",
        "Water Ponding": "fa-water",
        "Rotting": "fa-disease",
        "Poor Ventilation": "fa-fan",
        "Gutter Issues": "fa-down-left-and-up-right-to-center"
    };
    return map[title] || "fa-hammer";
};

// --- Sub Components ---
const Sidebar = () => (
    <motion.div
        className="col-lg-2 rps-sidebar-wrapper"
        initial={{ x: -50, opacity: 0 }}
        whileInView={{ x: 0, opacity: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8 }}
    >
        <div className="rps-sidebar-text font">
            Get My Instant Roof Quote
        </div>
    </motion.div>
);

const CardItem = ({ item, index }) => (
    <motion.div
        className="col-md-6 col-lg-4 rps-col"
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-50px" }}
        transition={{ delay: index * 0.1, duration: 0.5 }}
    >
        <div className="rps-card">
            <div>
                <i className={`fa-solid ${getIconClass(item)}`}></i>
            </div>
            <h5 className="rps-card-title">{item}</h5>
        </div>
    </motion.div>
);

// --- Main Component ---
const ProblemsSection = () => {
    const [showModal, setShowModal] = useState(false);

    const handleClose = () => setShowModal(false);
    const handleShow = () => setShowModal(true);

    return (
        <section className="rps-section-container font-hauora">
            <div className="container-fluid p-0">
                <div className="row g-0">
                    <Sidebar />

                    <div className="col-lg-10 rps-main-content cs-section font-hauora">
                        {/* Header Text */}
                        <motion.div
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.8, delay: 0.2 }}
                        >
                            <div className='cs-badge text-lg-start text-center d-flex justify-content-lg-start justify-content-center'>
                                <Badge text="Problems We Fix" />
                            </div>

                            <h2 className="cs-title service-header text-lg-start text-md-center text-sm-center text-center">
                                Common Roofing Problems We Fix
                            </h2>

                            <p className="cs-desc section-description text-lg-start text-md-center text-sm-center text-center">
                                Emergency roof issues demand fast action. Contact us now for immediate, reliable repairs.
                                Our team responds quickly to protect your home and prevent costly damage.
                            </p>
                        </motion.div>

                        {/* Grid */}
                        <div className="row font-hauora cs-content">
                            {roofingIssues.map((issue, index) => (
                                <CardItem key={index} item={issue} index={index} />
                            ))}
                        </div>
                    </div>
                </div>
            </div>

            {/* Chat Button */}
            <motion.button
                onClick={handleShow}
                className="rps-chat-btn border-0"
                initial={{ scale: 0 }}
                whileInView={{ scale: 1 }}
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 0.95 }}
                transition={{
                    type: "spring",
                    stiffness: 260,
                    damping: 20,
                    delay: 0.5
                }}
                style={{
                    cursor: "pointer",
                    background: "#b22335",
                    color: "#fff"
                }}
            >
                <IoChatbubbleEllipsesSharp />
                Let's chat
            </motion.button>

            {/* Modal */}
            <Modal
                show={showModal}
                onHide={handleClose}
                centered
                className="modalpopup d-flex justify-content-center"
            >
                <Modal.Header closeButton>
                    <Modal.Title className="fontHauora">
                        Get Your Free Estimate
                    </Modal.Title>
                </Modal.Header>

                <div className="mx-auto justify-content-center my-2">
                    <div className="mx-2 px-md-1 px-2 text-center mb-0 pb-0">
                        <p className="text-center fontHauora mb-1">
                            Please call and email us with your Details
                        </p>

                        <div className="my-0">
                            <p className="my-0 py-0 fontLight">
                                <FaPhoneVolume className="phone-icon ms-1 me-1" />
                                <span className="phone-number fontLight">
                                    614-357-7539
                                </span>
                            </p>

                            <p className="d-flex align-items-center gap-1 text-center justify-content-center fontLight pb-0 mb-0">
                                <MdEmail className="color" />
                                <span className="fontLight">
                                    roofs@ultimatesroofing.com
                                </span>
                            </p>
                        </div>
                    </div>

                    <p className="px-2 d-flex justify-content-center mx-auto text-center fontLight my-0 py-0">
                        OR
                    </p>

                    <p className="mx-2 text-center fontLight my-0 py-0">
                        Leave your Information below
                    </p>
                </div>

                <Modal.Body className="contact-modal-body mx-auto d-flex justify-content-center">
                    <ContactForm handleClose={handleClose} />
                </Modal.Body>
            </Modal>
        </section>
    );
};

export default ProblemsSection;